import {Component, Inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {Asset, ReviewAsset} from '@app/asset';

export class RemoveReviewItemData {
    asset: Asset;
    review: ReviewAsset;
}

export enum Result {
    Cancel,
    Remove,
    Delete,
}

@Component({
    selector: 'frog-remove-review-item-dialog',
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './remove-review-item-dialog.component.html',
    styleUrl: './remove-review-item-dialog.component.scss',
})
export class RemoveReviewItemDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<RemoveReviewItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RemoveReviewItemData,
    ) {}

    public remove(): void {
        this.dialogRef.close(Result.Remove);
    }

    public delete(): void {
        this.dialogRef.close(Result.Delete);
    }
}
